import { createSelector } from '@reduxjs/toolkit';

import { BOOTSTRAP_FEATURE_KEY, BootstrapState } from './bootstrap.slice';

export const getBootstrapState = (rootState: any): BootstrapState =>
  rootState[BOOTSTRAP_FEATURE_KEY];

export const selectBootstrapStatus = createSelector(
  getBootstrapState,
  (s) => s.status,
);
